import { DigitAgroWhiteIcon } from '@/common/icons/DigitAgroWhiteIcon';
import { MoniLogo } from '@/common/icons/MoniLogo';
import { Thermometer, Wind, Droplets, MapPin, Loader2 } from 'lucide-react';
import { useWeather } from './hooks/useWeather';
import { getWeatherDetails } from './utils';
import {
  CONTACT_ITEMS,
  SOCIAL_LINKS,
  //  NAV_LINKS
} from './constants';
// import { Link } from 'react-router-dom';

const BrandSection = () => (
  <div className="flex flex-col">
    <div className="mb-4 flex items-center gap-2">
      <MoniLogo className="h-9 w-9" />
      <span className="text-[15px] font-semibold text-white">
        Monitoring tizimi
      </span>
    </div>
    <p className="mb-5 text-[13px] leading-relaxed text-zinc-400">
      © 2026 "Monitoring tizimi".
      <br />
      Barcha huquqlar himoyalangan
    </p>

    <div className="mt-6 flex items-center gap-2 text-[13px] text-zinc-400">
      <DigitAgroWhiteIcon />
      <span>tomonidan ishlab chiqilgan</span>
    </div>
  </div>
);

// const NavSection = () => (
//   <div>
//     <h4 className="mb-5 text-sm font-medium text-white/70">
//       Monitoring tizimi
//     </h4>
//     <ul className="flex flex-col gap-1">
//       {NAV_LINKS.map((link) => (
//         <li key={link.label}>
//           <Link to={link.href} className="text-sm text-white">
//             {link.label}
//           </Link>
//         </li>
//       ))}
//     </ul>
//   </div>
// );

const WeatherSection = () => {
  const { data: weather, isLoading, isError } = useWeather();

  const today = new Date();
  const rawDateStr = today.toLocaleDateString('en-US', {
    weekday: 'long',
    day: 'numeric',
    month: 'long',
  });
  const dateStr = rawDateStr.charAt(0).toUpperCase() + rawDateStr.slice(1);

  const weatherDetails = weather
    ? getWeatherDetails(weather.weatherCode)
    : null;
  const WeatherIcon = weatherDetails ? weatherDetails.icon : null;

  return (
    <div>
      <h4 className="mb-5 text-sm font-medium text-white/70">Ob-havo</h4>
      <div className="flex flex-col gap-4">
        {isLoading ? (
          <div className="flex items-center gap-2 text-zinc-400">
            <Loader2 className="h-5 w-5 animate-spin" />
            <span className="text-sm">Yuklanmoqda...</span>
          </div>
        ) : isError || !weather ? (
          <div className="text-sm text-zinc-500">
            Ob-havo ma'lumotlarini yuklab bo'lmadi
          </div>
        ) : (
          <>
            <div className="flex flex-col gap-1.5">
              <div className="flex items-center gap-1.5 text-emerald-500">
                <MapPin className="h-3.5 w-3.5" />
                <span className="text-xs font-semibold uppercase tracking-wider">
                  Toshkent shahri
                </span>
              </div>
              <div className="flex items-center gap-3 text-white">
                {WeatherIcon && weatherDetails && (
                  <WeatherIcon className={`h-8 w-8 ${weatherDetails.color}`} />
                )}
                <div>
                  <div className="text-2xl font-semibold">{weather.temp}°C</div>
                  <div className="text-xs text-zinc-400">
                    {weatherDetails?.description}
                  </div>
                </div>
              </div>
            </div>

            <div className="flex flex-col gap-2 text-sm text-white">
              <div className="flex items-center gap-2">
                <Thermometer className="h-4 w-4 text-zinc-400" />
                <span className="text-zinc-400">Harorat:</span>
                <span>
                  {weather.tempMin}°C - {weather.tempMax}°C
                </span>
              </div>
              <div className="flex items-center gap-2">
                <Wind className="h-4 w-4 text-zinc-400" />
                <span className="text-zinc-400">Shamol:</span>
                <span>{weather.windSpeed} m/s</span>
              </div>
              <div className="flex items-center gap-2">
                <Droplets className="h-4 w-4 text-zinc-400" />
                <span className="text-zinc-400">Namlik:</span>
                <span>{weather.humidity}%</span>
              </div>
              <div className="text-xs text-zinc-400">{dateStr}</div>
            </div>
          </>
        )}
      </div>
    </div>
  );
};

const ContactSection = () => (
  <div>
    <h4 className="mb-5 text-sm font-medium text-white/70">Biz bilan aloqa</h4>
    <div className="flex flex-col gap-4">
      {CONTACT_ITEMS.map((item, index) => (
        <div
          key={index}
          className="flex items-start gap-2.5 text-sm text-white"
        >
          {item.icon}
          {item.content}
        </div>
      ))}
    </div>
  </div>
);

const SocialSection = () => (
  <div>
    <h4 className="mb-5 text-sm font-medium text-white/70">
      Bizga obuna bo&apos;ling
    </h4>
    <div className="grid grid-cols-1 gap-3 sm:grid-cols-2">
      {SOCIAL_LINKS.map((social) => (
        <a
          key={social.label}
          href={social.href}
          target="_blank"
          rel="noopener noreferrer"
          className="flex w-fit items-center gap-2 text-sm text-white"
        >
          {social.icon}
          {social.label}
        </a>
      ))}
    </div>
  </div>
);

export const Footer = () => {
  return (
    <footer>
      <div className="px-6 py-10">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-2 xl:grid-cols-4">
          <BrandSection />
          {/* <NavSection /> */}
          <ContactSection />
          <SocialSection />
          <WeatherSection />
        </div>
      </div>
    </footer>
  );
};
